import { httpCreate } from './http';

const http = httpCreate('/srv/sensitive');

export const sensitive = {
	add(data) {
		return http.post(``, data);
    },
    getList() {
        return http.get(``)
    },
    check(word) {
        return http.get(`/checkSys?words=${word}`)
    }
};
